import {
  chartConfig,
  getGeneralStatistics,
} from "../../states/statistics/Statistics.Helper";

import { CALL_API } from "admin/middlewares/api";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)
import moment from "moment";

export const TRANSACTIONS_RANGE_REQUEST = "TRANSACTIONS_RANGE_REQUEST";
export const TRANSACTIONS_RANGE_SUCCESS = "TRANSACTIONS_RANGE_SUCCESS";
export const TRANSACTIONS_RANGE_ERROR = "TRANSACTIONS_RANGE_ERROR";

export const STATISTICS_CALCULATED = "STATISTICS_CALCULATED";

export function fetch_transactions_range(from, to) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/transactions/statisticsdayrange?From=" +
        moment(from).format("YYYY-MM-DD") +
        "&To=" +
        moment(to).format("YYYY-MM-DD"),
      method: "GET",
      authenticatedRequest: true,
      types: [
        TRANSACTIONS_RANGE_REQUEST,
        TRANSACTIONS_RANGE_SUCCESS,
        TRANSACTIONS_RANGE_ERROR,
      ],
    },
  };
}

export const STATISTICS_RANGE_COMBINED_REQUEST =
  "STATISTICS_RANGE_COMBINED_REQUEST";
export const STATISTICS_RANGE_COMBINED_SUCCESS =
  "STATISTICS_RANGE_COMBINED_SUCCESS";
export const STATISTICS_RANGE_COMBINED_ERROR =
  "STATISTICS_RANGE_COMBINED_ERROR";

function calculate(
  from,
  to,
  selectedRangeType,
  actionTypesToDisplay,
  response,
) {
  return (dispatch) => {
    // do calculations
    setTimeout(() => {
      let data = {};
      data.chart = chartConfig(
        actionTypesToDisplay,
        selectedRangeType,
        response.Transactions,
        from,
        to,
      );
      data.statistics = getGeneralStatistics(
        response.Usage,
        response.Transactions,
      );
      dispatch({ type: STATISTICS_CALCULATED, response: data });
    }, 0);
  };
}

export function fetch_combined_statistics_range(
  from,
  to,
  selectedRangeType,
  actionTypesToDisplay,
) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/usage/statisticsdayrange?From=" +
        moment(from).format("YYYY-MM-DD") +
        "&To=" +
        moment(to).format("YYYY-MM-DD"),
      method: "GET",
      authenticatedRequest: true,
      types: [
        STATISTICS_RANGE_COMBINED_REQUEST,
        {
          method: calculate.bind(
            this,
            from,
            to,
            selectedRangeType,
            actionTypesToDisplay,
          ),
        },
        STATISTICS_RANGE_COMBINED_ERROR,
      ],
    },
  };
}
